import { render, staticRenderFns } from "./SubscriptionsType.vue?vue&type=template&id=0c202b0c&scoped=true"
import script from "./SubscriptionsType.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsType.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionsType.vue?vue&type=style&index=0&id=0c202b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c202b0c",
  null
  
)

export default component.exports